import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { api } from "@/lib/api";
import { resolveImageUrl } from "@/lib/media";

const FALLBACK_PROGRAMS = [
  { num: "01", title: "Elderly Physiotherapy", img: "https://images.pexels.com/photos/7551627/pexels-photo-7551627.jpeg" },
  { num: "02", title: "Special Needs Care", img: "https://images.pexels.com/photos/7943455/pexels-photo-7943455.jpeg" },
  { num: "03", title: "Athlete Rehabilitation", img: "https://images.unsplash.com/photo-1645005513713-9e2b92a687d3" },
];

export const ProgramsPreview = () => {
  const [programs, setPrograms] = useState(FALLBACK_PROGRAMS);

  useEffect(() => {
    api.get("/content/programs").then((res) => {
      if (res.data?.programs?.length) setPrograms(res.data.programs.slice(0, 3));
    }).catch(() => {});
  }, []);

  return (
  <section className="py-24 md:py-32 px-5 md:px-10">
    <div className="max-w-7xl mx-auto">
      <Reveal>
        <p className="text-accent text-sm tracking-[0.2em] uppercase mb-4 font-medium">What We Do</p>
        <h2 className="font-heading text-3xl md:text-5xl tracking-tight max-w-2xl">
          Three communities. One mission of movement.
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-16">
        {programs.map((p, i) => (
          <Reveal key={p.num} delay={i * 0.12}>
            <Link to="/programs" data-testid={`home-program-card-${p.num}`} className="group block border border-border hover:border-accent transition-colors">
              <div className="aspect-[4/3] overflow-hidden">
                <img src={resolveImageUrl(p.img)} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <div className="p-6">
                <span className="font-heading text-3xl text-accent">{p.num}</span>
                <h3 className="font-heading text-xl mt-3">{p.title}</h3>
                <span className="inline-flex items-center gap-1 text-sm mt-4 text-foreground/70 group-hover:text-accent transition-colors">
                  Learn more <ArrowUpRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
  );
};
